module.exports = __webpack_public_path__ + "img/img_title@2x.fc182a71.png";